import { render, staticRenderFns } from "./formelement_textareapicker_view.vue?vue&type=template&id=3bf1bfdc&"
import script from "./formelement_textareapicker_view.vue?vue&type=script&lang=js&"
export * from "./formelement_textareapicker_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports